<template>
	<div class="resource_main">
		<div class="tab_head">
			<div class="tab_item" @click="goImage()">
				<img src="../../assets/img/resource/pic.png"/>
				<span>图片</span>
			</div>
			<div class="tab_item tab_check">
				<img src="../../assets/img/resource/check_video.png"/>
				<span>视频</span>
			</div>
		</div>
		
		<div style="width: 200px;max-height: 800px;">
			<category-list :category_type="type" @chooseCategory="getContent" :is_search="false"></category-list>
		</div>
		
		<div class="resource_cont">
			<div style="padding-left: 20px;margin-bottom: 10px;display: inline-flex;">
				<el-upload
				  action=""
				  :http-request="fnUploadRequest"
				  :show-file-list="false"
				  :before-upload="beforeUploadVideo">
				  <el-button type="primary">上传视频素材</el-button>
				</el-upload>
				<el-button :disabled="checks.length <= 0" @click="batchMove()" style="margin-left: 20px;">批量移动</el-button>
				<el-button :disabled="checks.length <= 0" @click="batchDel()" style="margin-left: 20px;">批量删除</el-button>
			</div>
			<div v-if="video_arr.length == 0" class="empty">
				<img src="../../assets/img/promotion/ztd_empty.png" />
				<div style="margin-top: 10px;">点击上传素材按钮，可将视频素材上传至当前分组</div>
				<div>支持mp4、mov、3gp、m3u8视频格式</div>
			</div>
			<div v-else>
				<div v-if="video_arr.length > 0" style="min-height: 500px;">
					<el-row :gutter="15" style="margin-left: 12px;">
						<el-checkbox-group v-model="checks">
							<el-col :span="4" v-for="(item,index) in video_arr">
								<div class="pic_item" :class="'pic_item_'+index" @mouseenter="enter('v_',index)" @mouseleave="leave('v_',index)">
									<el-checkbox :label="item.id">
										<el-image class="pic" :src="item.cover_url" fit="cover"></el-image>
										<img src="../../assets/img/goods/play.png" class="play-icon" @click="previewVideo(item.url)" />
									</el-checkbox>
									<el-row class="opt_btn" :id="'v_opt_btn_'+index">
										<el-col :span="8" style="text-align: center;">
											<i class="el-icon-search" @click="previewVideo(item.url)"></i>
										</el-col>
										<el-col :span="8" style="text-align: center;">
											<i class="el-icon-download" @click="download(item.id)"></i>
										</el-col>
										<el-col :span="8" style="text-align: center;">
											<i class="el-icon-delete" @click="delVideo(item.id)"></i>
										</el-col>
									</el-row>
								</div>
							</el-col>
						</el-checkbox-group>
					</el-row>
				</div>
				
				<!-- 分页器 -->
				<div class="pager-box" v-if="video_arr.length > 0">
					<el-pagination align='center' @size-change="handleSizeChange"
						@current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
						layout="total, prev, pager, next" :pager-count='5' :total="total">
					</el-pagination>
				</div>
			</div>
		</div>
		
		<el-dialog width="540px" :visible.sync="showPreviewDialog" :before-close="closePreviewDialog">
			<video autoplay="autoplay" :src="previewVideoUrl" style="width: 500px;height: 480px;" controls="">您的浏览器不支持视频播放</video>
		</el-dialog>
		
		<remove-media :media_ids="checks" :type="type" :show="showRemoveDialog" @close="closeMove" @success="successMove"></remove-media>
	</div>
</template>

<script>
	import {
		addMedia,
		getImportList,
		batchDel,
		batchMove
	} from '@/api/depot_media';
	import categoryList from '@/components/category/list.vue';
	import removeMedia from '@/components/media/remove.vue';
	import oss from '@/utils/oss';
	import {
		baseURL,
		noPermissionCode
	} from '@/config';
	
	export default {
		components: {
			categoryList,
			removeMedia
		},
	    data() {
			return {
				category_id:0, // 类别id
				type:2, // 素材类型 视频
				video_arr:[], // 页面数据
				currentPage:0,
				pageSize:18,
				total:0, // 总数量
				checks:[], // 选中的
				showRemoveDialog: false, // 是否展示移动弹框
				downloadurl:baseURL+"/Api/brand.NoAuth/downLoadMedia", // 下载链接
				
				showPreviewDialog:false,
				uploadList: [], // 自定义的数组，用于处理fileList，fileList是只读的
				// ======= 视频上传
				videoFlag: false, //是否显示进度条
				previewVideoUrl: '',
				upload: {
					// 设置上传的请求头部
					headers: {
						authorization: this.$store.getters['user/accessToken'] ? this.$store.getters['user/accessToken'] :''
					},
					// 上传的地址
					url: baseURL + '/api/brand.Upload/oneToOss'
				},
			}
	    },
		created(){
			this.getContent(0);
		},
	    methods: {
			// 获取右侧数据
			getContent(e){
				var that = this;
				that.category_id = e;
				
				var currentPage = that.currentPage;
				if (currentPage > 0) {
					currentPage = currentPage - 1;
				}
				getImportList({
					type:that.type,
					start:currentPage * that.pageSize,
					limit:that.pageSize,
					category_id:e
				}).then(res=>{
					that.total = res.data.allcount;
					that.video_arr = res.data.list;
				})
			},
			// 批量移动
			batchMove(){
				this.showRemoveDialog = true;
			},
			// 关闭移动弹框
			closeMove(){
				this.showRemoveDialog = false;
			},
			// 移动成功
			successMove(){
				this.showRemoveDialog = false;
				this.checks = [];
				this.currentPage = 0;
				this.getContent(this.category_id);
			},
			// 批量删除
			batchDel(){
				const h = this.$createElement
				this.$confirm('提示', {
					message: h('div', [h('p', '确认删除该素材吗？'), h('p', '注：删除素材后与之关联的商品素材信息将同步删除')]),
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					batchDel({
						media_ids: this.checks
					}).then(res => {
						if (res.code == 0) {
							this.checks = [];
							this.$message.success(res.message);
							this.getContent(this.category_id);
						}else{
							this.$message.error(res.message);
						}
					})
				})
			},
			//每页条数改变时触发 选择一页显示多少行
			handleSizeChange(val) {
				this.currentPage = 1;
				this.pageSize = val;
			},
			//当前页改变时触发 跳转其他页
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getContent(this.category_id);
			},
			/**
			 * @description [fnUploadRequest 覆盖默认的上传行为，实现自定义上传]
			 * @params {object} option [上传选项]
			 * @return {null} [没有返回]
			 */
			async fnUploadRequest(option) {
				// var videoDOM = document.getElementById("hidden_video");
				// if (videoDOM.duration > 60) {
				// 	this.$message.error("视频时长请限制在1分钟内");
				// 	this.videoFlag = false;
				// 	return false;
				// }
				oss.ossUploadFile(option).then((res) => {
					this.videoFlag = false;
					if (res.errcode === 0) {
						if (res.data.code == 0) {
							const vc_idx = res.data.data.video_cover_url.lastIndexOf("?");
							const cover_url = res.data.data.video_cover_url.substring(0,vc_idx);
							const v_idx = res.data.data.video_url.lastIndexOf("?");
							const video_url = res.data.data.video_url.substring(0,v_idx);
							
							addMedia({
								type: 2,
								cover_id:res.data.data.video_cover,
								cover_url: cover_url,
								file_id: res.data.data.video_id,
								file_url: video_url,
								category_id: this.category_id
							}).then(result => {
								if (result.code == 0) {
									var newVideo = {
										id: result.data,
										file_id: res.data.data.video_id,
										cover_file_id: res.data.data.video_cover,
										cover_url: res.data.data.video_cover_url,
										url: res.data.data.video_url
									}
									this.video_arr.push(newVideo);
								}
							})
						} else {
							this.$message.error("上传失败");
						}
					} else {
						this.$message.error(res.errmsg);
					}
				});
			},
			//视频上传前回调
			beforeUploadVideo(file) {
				var fileSize = file.size / 1024 / 1024 < 300;
				if (['video/mp4', 'video/3gp', 'video/m3u8', 'video/mov','application/x-mpegurl','audio/x-mpegurl','video/quicktime','video/3gpp'].indexOf(file.type) === -1) {
					this.$message.error("视频格式仅支持：mp4，3gp，m3u8，mov");
					return false;
				}
				if (!fileSize) {
					this.$message.error("视频大小不能超过300MB");
					return false;
				}
				this.videoFlag = true;
			},
			closePreviewDialog(done) {
				done();
				this.previewVideoUrl = '';
			},
			// 预览视频
			previewVideo(url) {
				this.previewVideoUrl = url;
				this.showPreviewDialog = true;
			},
			// 文件上传时的钩子
			onthecross() {
				var circle = document.getElementsByClassName("el-progress-circle");
			
				if (circle[0]) {
					circle[0].style.width = "80px";
					circle[0].style.height = "80px";
				}
			},
			
			// 下载图片或视频
			download(id){
				var link = document.createElement("a");
				link.download = 'muban';
				link.href = this.downloadurl + '?media_id=' + id ;
				link.click();
				link.remove();
			},
			// 去图片素材
			goImage(){
				this.$router.push({
					path: '/separation/resource-image',
					query: {}
				});
			},
			// 鼠标移入图片时
			enter(prefix,index){
				var t = document.getElementById(prefix+'opt_btn_'+index);
				t.style.display="block"; // 设置显示元素
			},
			// 鼠标离开图片时
			leave(prefix,index){
				var t = document.getElementById(prefix+'opt_btn_'+index);
				t.style.display="none"; // 设置隐藏元素
			},
			// 删除图片
			delVideo(id){
				this.checks = [id];
				this.batchDel();
			}
		},
	}
</script>

<style scoped>
	.resource_main{
		width: 100%;
		min-height: 800px;
		max-height: 800px;
		background-color: #ffffff;
		display: flex;
	}
	.resource_main .tab_head{
		width: 55px;
		min-height: 800px;
		max-height: 800px;
		background: #F0F2F5;
		border-radius: 4px;
	}
	.resource_main .tab_item{
		height: 217px;
		padding: 78px 9px;
		text-align: center;
		box-sizing: border-box;
		color: #333333;
		cursor: pointer;
	}
	.resource_main .tab_item img{
		width: 36px;
		height: 36px;
	}
	.resource_main .tab_head span{
		font-size: 12px;
	}
	.resource_main .tab_check{
		border-right:1px solid #eeeeee;
		background-color: #ffffff;
		color: #409EFF !important;
		border-radius: 4px;
	}
	/* 右侧内容样式 */
	.resource_cont{
		width: 100%;
		padding: 20px 17px;
	}
	
	.empty {
		width: 100%;
		height: 500px;
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: center;
	}
	.empty img {
		width: 126px;
		height: 140px;
	}
	.empty div {
		font-size: 12px;
		font-weight: 500;
		color: #999999;
		line-height: 17px;
	}
	.pic_blo{
		padding: 0 20px;
	}
	.pic_item{
		position:relative;
		width:100%;
		height:0;
		padding-top:100%;
		margin-top: 20px;
	}
	.pic_item >>> .el-checkbox{
		position:absolute;
		top:0;
		width:100%;
		height:100%;
	}
	.pic{
		position:absolute;
		top:0;
		left:0;
		width:100%;
		height:100%;
		border-radius: 4px;
	}
	.play-icon{
		width: 35%;
		height: 35%;
		position: absolute;
		left: calc(65% / 2);
		top: calc(65% / 2);
	}
	.opt_btn{
		width: 100%;
		height: 28px;
		padding: 3px 10px;
		position:absolute;
		bottom:-20px;
		background: rgba(0,0,0,0.5);
		border-radius: 0px 0px 4px 4px;
		color: #ffffff;
		font-size: 16px;
		display: none;
	}
	.opt_btn i{
		cursor: pointer;
	}
	
	.el-row {
	    margin-bottom: 20px;
	    &:last-child {
	      margin-bottom: 0;
	    }
	}
	.pic_item >>> .el-checkbox__inner{
		width: 16px;
		height: 16px;
		top: 8px;
		left: 8px;
	}
</style>